import crypto from 'crypto'

const createGravatar = email => {
    const gravatarUrl = crypto.createHash('md5').update(email.trim().toLowerCase()).digest('hex');
    const fullUrl = `https://www.gravatar.com/avatar/${gravatarUrl}.jpg?d=robohash`
    return fullUrl;
}

export default createGravatar;